const raw = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000';

/** Backend origin without trailing slash (e.g. http://localhost:4000) */
export const apiBaseUrl = raw.replace(/\/$/, '');

/** API prefix with trailing slash (e.g. http://localhost:4000/api/) */
export const apiPath = `${apiBaseUrl}/api/`;
